import { DashboardLayout } from "src/components/dashboard";
import filterIcon from "src/assets/images/common/filter.svg";
import { useEffect, useState } from "react";
import { FilterButton } from "src/styles/commonStyle";
import { Link, useParams } from "react-router-dom";
import { Flex, Table, Button, ButtonClass } from "src/components/ui";
import arrowLeft from "src/assets/images/common/arrowLeft.svg";
import { theme } from "src/styles/Theme";
import { formatDateDmy } from "src/utils/helpers";
import { DateRangeFilter } from "src/components/common";
import { addDays } from "date-fns";
import AdminProfileDetails from "src/components/admin/AdminProfileDetails";
import { ADMINLOG } from "src/constants/ADMINLOG";
import {
  AdminActivityTableContainer,
  StyledAdminProfileComponent,
  StyledProfileHeader,
} from "src/components/admin/admin-style";
import { useLoading } from "src/hooks";
import { ScaleLoader } from "react-spinners";
import { toast, ToastContainer } from "react-toastify";
import { usePagination } from "src/hooks/usePagination";
import { useGetAdminQuery } from "src/store/services/adminApi";
import { AdminProfileTypes } from "./adminTypes";

const AdminProfile = () => {
  const AdminActivityTableHeaders = [
    {
      title: "Date",
      render: (row: any) => formatDateDmy(row.createdAt),
    },
    {
      title: "Action Type",
      render: (row: any) => `${row.action}`,
    },
  ];

  //Date filter
  const [openDateFilter, setOpenDateFilter] = useState(false);
  const handleOpenDateFilter = () => setOpenDateFilter(true);
  const handleCloseDateFilter = () => setOpenDateFilter(false);
  const [status, setStatus] = useState("");
  const [startDate, setStartDate] = useState<Date>(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date;
  });
  const [endDate, setEndDate] = useState<Date>(new Date());

  const [state, setState] = useState([
    {
      startDate: new Date("2020-01-01"),
      endDate: addDays(new Date(), 0),
      key: "selection",
      color: theme.colors.darkPurple,
    },
  ]);

  const { id } = useParams();
  const [adminEntry, setAdminEntry] = useState<AdminProfileTypes>({
    admin: {
      _id: "",
      first_name: "",
      last_name: "",
      email: "",
      role: [],
      suspended: "",
      display_picture: "",
      createdAt: "",
    },
    activity: [],
  });

  const { loading } = useLoading();
  const { data: adminResp, isLoading: isLoadingAdmin } = useGetAdminQuery(
    id as string,
    { skip: !id },
  );
  useEffect(() => {
    const payload: any = adminResp?.payload?.data;
    if (!payload) return;
    setAdminEntry(payload);
  }, [adminResp]);

  useEffect(() => {
    id &&
      (document.title = `${adminEntry.admin.first_name} ${adminEntry.admin.last_name}`);
  }, [id, adminEntry]);

  const { page, limit, Pagination } = usePagination({
    page: 1,
    limit: 10,
    total: adminEntry.activity.length,
  });
  const paginatedRows = adminEntry.activity.slice(
    (page - 1) * limit,
    page * limit,
  );

  return (
    <DashboardLayout>
      <ToastContainer />
      <DateRangeFilter
        open={openDateFilter}
        handleClose={handleCloseDateFilter}
        state={state}
        setState={setState}
        onApply={() => {}}
      />
      <StyledAdminProfileComponent>
        <StyledProfileHeader>
          <h2>
            {adminEntry.admin.first_name &&
              `${adminEntry.admin.first_name} ${adminEntry.admin.last_name}'s profile`}
          </h2>
          <Link to="/admins">
            <Button
              classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
              style={{ backgroundColor: theme.colors.purple }}
            >
              {" "}
              <img src={arrowLeft} alt="back" />
              <span>Back to Admins</span>
            </Button>
          </Link>
        </StyledProfileHeader>
        {isLoadingAdmin ? (
          <div className="loader-container">
            <ScaleLoader color="#7E00C4" height={50} width={8} />
          </div>
        ) : (
          <AdminProfileDetails adminEntry={adminEntry} getAdmin={() => {}} />
        )}

        <AdminActivityTableContainer>
          <div className="heading">
            <Flex justify="space-between" align="center">
              <p className="title"> Activity Log</p>
              {/* <FilterButton onClick={handleOpenDateFilter}>
								<img src={filterIcon} alt='' width={24} height='24px' />
								Filter
							</FilterButton> */}
            </Flex>
          </div>

          {paginatedRows.length > 0 ? (
            <>
              <Table
                rows={paginatedRows}
                headers={AdminActivityTableHeaders}
                showHead
                allowRowClick={false}
              />
              <Pagination />
            </>
          ) : (
            <p className="pd-20">No Activity</p>
          )}
        </AdminActivityTableContainer>
      </StyledAdminProfileComponent>
    </DashboardLayout>
  );
};

export default AdminProfile;
